import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_PLAYERS_BONUSES_CREATE_ROUTE_NAME } from '@modules/players-bonuses/submodules/create/constants';
import {
  PLAYERS_BONUS_CREATE_MANUALLY_ROUTE_NAME,
  TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY,
} from '@modules/players-bonuses/submodules/create/submodules/manually-bonus-create/constants';
import {
  getTranslationKeys,
} from '@modules/players-bonuses/submodules/create/submodules/manually-bonus-create/translations';

export class ManuallyBonusCreateModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PLAYERS_BONUSES_CREATE_ROUTE_NAME, {
      name: PLAYERS_BONUS_CREATE_MANUALLY_ROUTE_NAME,
      path: 'manually',
      component: () => import('@modules/players-bonuses/submodules/create/submodules/manually-bonus-create/pages/ManuallyBonusCreate/ManuallyBonusCreate.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY, getTranslationKeys);
  }
}
